import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const listarAgendamento = (status) => {
  const route = status ? '/listar-por-status/' + status : ''
  const url = `${process.env.URL_API_BASE}/agendamento${route}`

  return axios
    .get(url, config)
    .then(result => result.data)
}

const listarPorMotorista = (codigoMotorista) => {
  const url = `${process.env.URL_API_BASE}/agendamento/listar/${codigoMotorista}`

  return axios
    .get(url, config)
    .then(result => result.data)
}

const obterAgendamento = (id) => {
  const url = `${process.env.URL_API_BASE}/agendamento/${id}`

  return axios
    .get(url, config)
    .then(result => result.data)
}

const criarAgendamento = ({
  cd_motorista,
  cd_ponto_apoio,
  idc_status,
  dt_agendada
}) => {
  const url = `${process.env.URL_API_BASE}/agendamento/criar-agendamento/${cd_motorista}`

  return axios.post(
    url,
    {
      cd_motorista,
      cd_ponto_apoio,
      idc_status,
      dt_agendada
    },
    config
  )
}

const alterarAgendamento = ({
  id,
  idc_status,
  dt_agendada,
  cd_ponto_apoio
}) => {
  const url = `${process.env.URL_API_BASE}/agendamento/${id}`

  return axios.patch(
    url,
    {
      idc_status,
      dt_agendada,
      cd_ponto_apoio,
      updated_by: ActionsLogin.getUsuario().cd_usuario
    },
    config
  )
}

const alterarStatusEmLote = async (ids, status) => {
  const url = `${process.env.URL_API_BASE}/agendamento/alterar-status-lote/${ids}`

  return axios
    .patch(url, { idc_status: status }, config)
    .then(result => result.data)
}

export default {
  listarAgendamento,
  listarPorMotorista,
  obterAgendamento,
  alterarAgendamento,
  alterarStatusEmLote,
  criarAgendamento
}



// WEBPACK FOOTER //
// ./src/actions/AgendamentoActions.js